// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
//import useJwt from '@src/auth/jwt/useJwt'
//const config = useJwt.jwtConfig
// const headers = {
//   token: JSON.parse(localStorage.getItem(config.storageTokenKeyName)),
//   userID: JSON.parse(localStorage.getItem('userID'))
// }
export const resetFlag = createAsyncThunk('driverProfile/ResetFlag', () => {

  return { isSaved: 0 }
})
export const getAllData = createAsyncThunk('driverProfile/GetTableSummary', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriverDrvApp', params, { mode: 'cors' })

  return response.data
})
export const getGenerateDocumentDrvrPayment = createAsyncThunk('appDriver/getGenerateDocumentDrvrPayment', async (DocumentExcel) => {

  const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetGenerateDocumentDriverPayment', DocumentExcel, { mode: 'cors' })

  return response.data
})
export const getDocument = createAsyncThunk('appDriver/getDocument', async (Doc) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocument', Doc, { mode: 'cors' })
  return response.data
})
export const deleteDocument = createAsyncThunk('appDriver/DeleteDocument', async (id) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/DeleteDocument', id, { mode: 'cors' })
  return response
})
export const getDocumentTypeList = createAsyncThunk('appDriver/getDocumentTypeList', async (OwnerType) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentTypeList', OwnerType, { mode: 'cors' })

  return response.data
})
export const GetDocumentDetailsByOwnerType = createAsyncThunk('appDriver/GetDocumentDetailsByOwner', async (Owner) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentSummaryByOwnerType', Owner, { mode: 'cors' })

  return response.data
})
export const GetDocumentDetailsByID = createAsyncThunk('appDriver/GetDocumentDetailsByID', async (document) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentDetailByID', document, { mode: 'cors' })

  return response.data
})
export const addDocument = createAsyncThunk('driverProfile/CreateDocument', async (formData) => {

  let flag = 0
  const response = await axios.post('https://api.zasway.com:8443/Common/Create', formData, { mode: 'cors' })

  if (response.data.code === 200) { flag = 1 }
  return {

    response,
    isSaved: flag
  }
})
export const EditDocument = createAsyncThunk('driverProfile/UpdateDocument', async (formData) => {

  let flag = 0
  const response = await axios.post('https://api.zasway.com:8443/Common/UpdateDocument', formData, { mode: 'cors' })

  if (response.data.code === 200) { flag = 1 }
  return {

    response,
    isSaved: flag
  }
})
export const GetDriverTag = createAsyncThunk('driverProfile/GetDriverTagList', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverTagList', params, { mode: 'cors' })

  return response.data
})

export const deleteDriverAccount = createAsyncThunk('driverProfile/DeleteDriverAccount', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/DeleteDriverAccount', params, { mode: 'cors' })

  return response.data
})

export const driverProfileSlice = createSlice({
  name: 'driverProfile',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    selectedDocument: [],
    IsSaved: 0,
    IsClosed: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.data = action.payload
      })
      .addCase(addDocument.fulfilled, (state, action) => {

        state.IsSaved = action.payload.isSaved
      })
      .addCase(EditDocument.fulfilled, (state, action) => {

        state.IsSaved = action.payload.isSaved
      })
      .addCase(resetFlag.fulfilled, (state, action) => {

        state.IsSaved = action.payload.isSaved
      })
  }
})

export default driverProfileSlice.reducer
